import { render, staticRenderFns } from "./ForgetPasswordTwo.vue?vue&type=template&id=1ef80b0e&scoped=true"
import script from "./ForgetPasswordTwo.vue?vue&type=script&lang=js"
export * from "./ForgetPasswordTwo.vue?vue&type=script&lang=js"
import style0 from "./ForgetPasswordTwo.vue?vue&type=style&index=0&id=1ef80b0e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ef80b0e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCard,VCol,VRow,VTextField})
